import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import styles from "@/components/ui/breadcrumb/BreadcrumbComponent.module.css";

const BreadcrumbComponent = ({ location }) => {
  const router = useRouter();
  const [pathnames, setPathnames] = useState(
    router.asPath.split("/").filter((x) => x)
  );

  useEffect(() => {
    // Set timeout to delay the breadcrumb update
    const timeoutId = setTimeout(() => {
      setPathnames(router.asPath.split("/").filter((x) => x));
    }, 200); // 200 milliseconds delay

    // Clean up function to clear the timeout
    return () => clearTimeout(timeoutId);
  }, [router.asPath]);

  return (
    <motion.nav
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className={styles.breadcrumb}>
      <ul>
        <li>
          <Link href="/">Home</Link>
        </li>
        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const name = isLast && location ? location : value;
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          return (
            <li key={name}>
              <Link className={styles.breadcrumbLink} href={routeTo}>
                {name}
              </Link>
            </li>
          );
        })}
      </ul>
    </motion.nav>
  );
};

export default BreadcrumbComponent;
